import { useEffect } from 'react';

export function useTitle(title: string | undefined | null): void {
  useEffect(() => {
    const prevTitle = document.title;

    if (title) {
      document.title = title + " - " + prevTitle;
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}
